export default import.meta.ROLLDOWN_FILE_URL_ceYaf0BiqlvrKpQrMEua_A